<template>
  <FormGroup :error="touched && !valid">
    <div class="colour-input">
      <!-- Native colour input drives the picker UI; the paired text input lets the
           user type/paste a hex value directly since <input type="color"> can't. -->
      <input
        v-if="isValidHexColour(copy)"
        type="color"
        class="colour-input__picker"
        :value="copy"
        :disabled="readOnly"
        @input="updateFromPicker($event.target.value)"
      />
      <FormInput
        ref="input"
        v-model="copy"
        size="large"
        :error="touched && !valid"
        :disabled="readOnly"
        @keyup.enter="$refs.input.blur()"
        @focus="select()"
        @blur="unselect()"
      />
    </div>
    <template #error>
      <span v-show="touched && !valid">
        {{ error }}
      </span>
    </template>
  </FormGroup>
</template>

<script>
import rowEditField from '@baserow/modules/database/mixins/rowEditField'
import rowEditFieldInput from '@baserow/modules/database/mixins/rowEditFieldInput'
import { isValidHexColour } from '@baserow/modules/core/utils/string'

export default {
  mixins: [rowEditField, rowEditFieldInput],
  methods: {
    isValidHexColour,
    updateFromPicker(newValue) {
      this.copy = newValue
      this.touch()
      this.save()
    },
  },
}
</script>
